import { combineReducers } from 'redux';
import { GRIANA_REDUCER } from '../griana/redux';
import { SIPRO_REDUCER } from '../sipro/redux';

export const MAPANA_REDUCER = combineReducers({
  GRIANA: GRIANA_REDUCER,
  SIPRO: SIPRO_REDUCER,
});
